import { DEFAULT_VC_IMAGE } from '@site-builder/common/src/utils/store';
import cn from 'classnames';
import React from 'react';

interface IVirtualPriceProps {
  img?: string;
  amount?: string;
  withoutDiscount?: boolean;
}

const VirtualPrice: React.FC<IVirtualPriceProps> = ({
  amount,
  img,
  withoutDiscount,
}: IVirtualPriceProps) => (
  <>
    <span
      className={cn('store__price-virtual-img', {
        'store__price-virtual-img--without-discount': withoutDiscount,
      })}
      style={{
        backgroundImage: `url(${img || DEFAULT_VC_IMAGE})`,
      }}
    />
    <span className='store__price'>{amount}</span>
  </>
);

export default VirtualPrice;
